import React from 'react';

const CustomModal = ({ isOpen, onClose, children }) => {
  if (!isOpen) return null;

  return (
    <div className="fixed z-50 inset-0 overflow-y-auto ml-3 mr-3">
    <div className="flex items-center justify-center min-h-screen">
      <div className="fixed inset-0 bg-black opacity-50"></div>
      <div className="z-50 rounded-lg">
        <div className="mt-4">{children}</div>
      </div>
    </div>
  </div>
  );
};

export default CustomModal;



{/* <div className="fixed z-50 inset-0 overflow-y-auto">


{/* <div className="fixed z-50 inset-0 overflow-y-auto">
<div className="flex items-center justify-center min-h-screen">
  <div className="fixed inset-0 bg-black opacity-50"></div>
  <div className="z-50 bg-white rounded-lg p-6 w-full max-w-md mx-auto">
    {/* <div className="flex justify-end">
      <button onClick={onClose} className="text-gray-500">Close</button>
    </div> */}
//     <div className="mt-4">{children}</div>
//   </div>
// </div>
// </div> */}